(() => {
  const SELECTORS = ['.t4s-product__info-container .t4s-product-price', '.t4s-product__info-container .t4s-price', '.product__info-container .price', '.product-single__price', '[data-product-price]', '.price'];
  let productData = null;

  function getVariantId() {
    const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value) return String(input.value);
    return new URLSearchParams(location.search).get('variant');
  }

  function getQuantity(variant) {
    if (!variant) return null;
    const values = Array.isArray(variant.options) ? variant.options : [];
    for (const value of values) {
      const text = String(value).trim().replace(/,/g, '');
      if (/^\d{2,6}$/.test(text)) {
        const quantity = Number(text);
        if (quantity >= 10) return quantity;
      }
    }
    const titleParts = String(variant.title || '').split('/').map(v => v.trim().replace(/,/g, ''));
    for (const part of titleParts) {
      if (/^\d{2,6}$/.test(part)) {
        const quantity = Number(part);
        if (quantity >= 10) return quantity;
      }
    }
    return null;
  }

  function money(cents) {
    const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CAD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
      style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2
    }).format(cents / 100);
  }

  function priceTarget() {
    for (const selector of SELECTORS) {
      const found = document.querySelector(selector);
      if (found && found.offsetParent !== null) return found;
    }
    return null;
  }

  function render() {
    if (!productData || !Array.isArray(productData.variants)) return;
    const id = getVariantId();
    const variant = productData.variants.find(v => String(v.id) === String(id)) || productData.variants[0];
    const quantity = getQuantity(variant);
    let row = document.querySelector('[data-ds-per-piece]');

    if (!quantity || !variant || typeof variant.price !== 'number') {
      if (row) row.hidden = true;
      return;
    }

    const target = priceTarget();
    if (!target) return;
    if (!row) {
      row = document.createElement('div');
      row.setAttribute('data-ds-per-piece', '');
      row.style.cssText = 'margin-top:8px;font-size:15px;font-weight:600;line-height:1.35;color:inherit;';
      target.insertAdjacentElement('afterend', row);
    }
    row.hidden = false;
    row.textContent = `${money(variant.price / quantity)} per piece`;
  }

  async function init() {
    if (!document.body.classList.contains('template-product')) return;
    try {
      const response = await fetch(`${location.pathname}.js`);
      if (!response.ok) return;
      productData = await response.json();
      render();
      document.addEventListener('change', event => {
        if (event.target.closest('form[action*="/cart/add"], variant-selects, variant-radios, [data-product-options]')) {
          setTimeout(render, 50);
          setTimeout(render, 250);
        }
      });
      document.addEventListener('variant:change', render);
      const observer = new MutationObserver(() => render());
      const form = document.querySelector('form[action*="/cart/add"]');
      if (form) observer.observe(form, { subtree: true, attributes: true, childList: true });
    } catch (error) {
      console.warn('Per-piece price could not load.', error);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();